module.exports = __webpack_public_path__ + "static/media/matilde-tired.e4d05f0c.png";